import axios, { AxiosStatusCode } from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as session from 'smg/customer-api/session';
import { ReportValidity } from 'smg/form';
import { InitGoogleCredentialHandler } from 'smg/googlesignin';
import Modal from 'smg/modal';
import { G } from 'smg/querystring';
import { Relref } from '../hugo';
import * as login from './login';

export default function main() {
    InitGoogleCredentialHandler(Relref('/dashboard'));

    const email = document.querySelector('#email') as HTMLInputElement;
    const password = document.querySelector('#password') as HTMLInputElement;
    const form = document.querySelector('#login-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const welcome = form.querySelector('h1') as HTMLHeadElement;
    const loginCode = document.querySelector('#login-code') as HTMLAnchorElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'invalid-email' | 'email-unverified') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        welcome.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    form.noValidate = true;
    form?.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity(form)) {
            return false;
        }

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        axios.post<login.LoginResp>('/sessions', {
            'email': email.value,
            'password': password.value,
        }).then(resp => {
            if (resp.data.token) {
                session.SetLoginToken(resp.data.token);
                window.location.href = G().Get('return') || Relref('/dashboard');
                return;
            }

            throw Error('Login failed!');
        }).catch(async err => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            switch (AxiosStatusCode(err)) {
            case 400:
                showAlert('invalid-email');
                return;
            case 401: {
                const prompt = await login.PromptLoginCode({ email: email.value });

                await prompt.login.then(() => window.location.href = Relref('/dashboard'));

                return prompt.createCode;
            }
            }
            showAlert('generic');
        });
    });

    loginCode.addEventListener('click', e => {
        e.preventDefault();

        const body = (document.querySelector('#modal-login-code-email') as HTMLTemplateElement).content.cloneNode(true) as DocumentFragment;

        const modalEmail = body.querySelector('#modal-email') as HTMLInputElement;
        modalEmail.value = email.value;

        new Modal({
            body,
            onSubmit: async () => {
                const prompt = await login.PromptLoginCode({ email: modalEmail.value });

                void prompt.login.then(() => window.location.href = Relref('/dashboard'));

                return prompt.createCode;
            },
            submitAutoFocus: false,
        });

        setTimeout(() => {
            modalEmail.focus();
            modalEmail.select();
        });
    });

    const googleBtn = document.querySelector('#google-cover-btn') as HTMLElement;

    googleBtn.addEventListener('click', () => {
        const hiddenGoogleBtn = document.querySelector('.g_id_signin') as HTMLElement;
        const googleTarget = hiddenGoogleBtn.querySelector('div[tabindex="0"]') as HTMLElement;

        googleTarget.dispatchEvent(new PointerEvent('click'));
    });
}